module.exports = __webpack_public_path__ + "officialStatic/img/case3.d183858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/case3.png
// module id = JVxh
// module chunks = 0